// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qbmbxbumamdhcircobcg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFibWJ4YnVtYW1kaGNpcmNvYmNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM1NzcxOTEsImV4cCI6MjA1OTE1MzE5MX0.ki_Z9LH5HRYIlrdWx1tydG_YLFwOIPiwUVEv6epGSjY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);